import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assete/Logo.svg";
import { FaAngleDown, FaBars, FaTimes } from "react-icons/fa";
import ShareStoryModal from "./ShareStoryModal";
import CustomizedSnackbars from "./CustomizedSnackbars";

const NavBar = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const [openMobileMenu, setOpenMobileMenu] = React.useState(false);
  // handle close mobile menu out of click outside
  const mobileMenuRef = useRef(null);
  const menuIconRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openMobileMenu &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        menuIconRef.current &&
        !menuIconRef.current.contains(event.target)
      ) {
        setOpenMobileMenu(false);
      }
    };

    if (openMobileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMobileMenu]);
  // const location = useLocation();
  // useEffect(() => {
  
  //   return () => {
  //     setOpenDropdown(false);
  //   }
  // }, [location.pathname])
  
  return (
    <>
    <div className="navBar">
      <div className="container">
        <div className="logo">
          <Link to="/">
          <img src={logo} className="w-100" alt="..." />
          </Link>
        </div>
        <ul className="menu">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/our-mission">Our Mission</Link>
          </li>

          {/* Dropdown */}
          <li className="dropdown">
            <Link >Ask an Expert <FaAngleDown /></Link>
            <ul className="dropdown-menu">
              <li><Link to="/ask-an-expert/biotechnology">Biotechnology</Link></li>
              <li><Link to="/ask-an-expert/genetics">Genetics</Link></li>
              <li><Link to="/ask-an-expert/molecular-biology">Molecular Biology</Link></li>
              <li><Link to="/ask-an-expert/biochemistry">Biochemistry</Link></li>
              <li><Link to="/ask-an-expert/ecology">Ecology</Link></li>
              <li><Link to="/ask-an-expert/zoology">Zoology</Link></li>
              <li><Link to="/ask-an-expert/botany">Botany</Link></li>
              <li><Link to="/ask-an-expert/microbiology">Microbiology</Link></li>
              <li><Link to="/ask-an-expert/other">Others</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/cv-review">CV Review</Link>
          </li>
          <li>
            <Link to="/media-room">Stories</Link>
          </li>
          <li>
            <Link to="/quick-news">Latest News</Link>
          </li>
        </ul>

        <div className="d-flex align-items-center action_btn_nav">
          <button onClick={handleOpen}>Share your Story</button>
          <button><Link style={{textDecoration: "none", color: "white"}} to="/contact-us">Contact Us</Link></button>
          <ShareStoryModal open={open} setOpen={setOpen} />
        </div>
        <div className="menu_icon" ref={menuIconRef}>
         { openMobileMenu ? <FaTimes onClick={() => setOpenMobileMenu(!openMobileMenu)} className="icon_menu" /> : <FaBars onClick={() => setOpenMobileMenu(!openMobileMenu)} className="icon_menu" />}
        </div>
      </div>
    <CustomizedSnackbars />

    </div>
    <div ref={mobileMenuRef} className={`mobile_menu ${openMobileMenu ? 'open' : ''}`}>
      <div className="mobile_menu_header logo">
        <Link to="/">
          <img src={logo} className="w-100" alt="..." />
        </Link>
      </div>
      <ul className="mobile_menu_list">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/our-mission">Our Mission</Link>
        </li>
        <li onClick={() => setOpenDropdown(!openDropdown)} className="menu_item_dropdown">
          <Link >Ask an Expert <FaAngleDown /></Link>
         { openDropdown && <ul className="menu_item_dropdown_list ms-3 mt-2">
            <li><Link to="/ask-an-expert/biotechnology">Biotechnology</Link></li>
            <li><Link to="/ask-an-expert/genetics">Genetics</Link></li>
            <li><Link to="/ask-an-expert/molecular-biology">Molecular Biology</Link></li>
            <li><Link to="/ask-an-expert/biochemistry">Biochemistry</Link></li>
            <li><Link to="/ask-an-expert/ecology">Ecology</Link></li>
            <li><Link to="/ask-an-expert/zoology">Zoology</Link></li>
            <li><Link to="/ask-an-expert/botany">Botany</Link></li>
            <li><Link to="/ask-an-expert/microbiology">Microbiology</Link></li>
            <li><Link to="/ask-an-expert/other">Others</Link></li>
          </ul>}
        </li>
        <li><Link to="/cv-review">CV Review</Link></li>
        <li><Link to="/media-room">Stories</Link></li>
        <li><Link to="/quick-news">Latest News</Link></li>
      </ul>
      <div className="mobile_action_btn_nav">
        <button onClick={()=>{
          setOpenMobileMenu(false);
          handleOpen();
        }}>Share your Story</button>
        <button className="contact_us_btn"><Link style={{textDecoration: "none", color: "#1A335D"}} to="/contact-us">Contact Us</Link></button>
      </div>
    </div>
    </>
  );
};

export default NavBar;
